module.exports = "/images/vendor/vue-paycard/src/chip.png?743f57476bbf244880353ddbcc123208";